import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import persentaseBiayaService from "../../../services/ref/persentaseBiayaService";
import Cookies from "js-cookie";

export const initialState = {
    loading_persentase_biaya: false,
    data_persentase_biaya: [],
    showMessage:false,
    message:'',
}


export const getDataPersentaseBiaya = createAsyncThunk('persentase_biaya/data',async (data, { rejectWithValue }) => {
    try {
        const response = await persentaseBiayaService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const persentaseBiayaSlice = createSlice({
    name: 'persentase_biaya',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_persentase_biaya = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPersentaseBiaya.fulfilled, (state, action) => {
                state.loading_persentase_biaya = false
                state.data_persentase_biaya = action.payload??[]
            })
            .addCase(getDataPersentaseBiaya.pending, (state) => {
                state.loading_persentase_biaya = true
            })
            .addCase(getDataPersentaseBiaya.rejected, (state, action) => {
                state.loading_persentase_biaya = false
                state.data_persentase_biaya = action.payload
            })
    },
})

export const {
    showLoading,
} = persentaseBiayaSlice.actions

export default persentaseBiayaSlice.reducer
